import axios from "./axios"
import { handleResponse } from "./util"

interface SuggestedTag {
  id: number,
  name: string,
  retailer: string,
  state: string,
  merchant_id: number
}

interface UpdateTag {
  brand_id: number,
  status: string,
  tags: Tag[]
}

interface Tag {
  merchant_id: number,
  tag_id: number
}

type TagType = 'linked' | 'retailers'

export const tagAPI = {
  /**
   * GET all suggested tags
   * @param {number} advertiserId - current advertiser ID
   */
  getSuggestedTags(advertiserId: number): Promise<SuggestedTag[]> {
    return axios.get(`/brands/${advertiserId}/linked_tags/suggested`)
      .then(handleResponse)
  },
  /**
   * POST update to selected tags
   * @param {number} advertiserId - current advertiser ID
   * @param {UpdateTag} params - contains all tags data to update
   */
  updateTag(advertiserId: number, params: UpdateTag): Promise<unknown> {
    return axios.post(`/brands/${advertiserId}/linked_tags`, params).then(handleResponse)
  },
  /**
   * DELETE a selected tag
   * @param {number} advertiserId - current advertiser ID
   * @param {number} tagId - selected tag ID to delete
   */
  deleteTag(advertiserId: number, tagId: number): Promise<unknown> {
    return axios.delete(`/brands/${advertiserId}/linked_tags/${tagId}`)
      .then(handleResponse)
  },
  getTags(advertiserId: number, tagType: TagType, currentPage: number, searchText: string) {
    let url = `/brands/${advertiserId}/`
    const params: any = {}
    if (tagType === 'retailers') {
      url += 'retailers'
    } else {
      url += `linked_tags`
      params.page = currentPage
      params.per_page = 20
    }

    if (searchText) {
      params.search = searchText
    }
    return axios.get(url, { params }).then(handleResponse)
  }
}